/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="payinoutreasons.module.ts" />

module Meevo.Plugins.PayInOutReasons {
    class PayInOutReasonsController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {
        criteria: any;
        static $inject = ["meevo.AppSettings", "meevo.components.common.DataService",
        "meevo.components.modal.ModalService", "meevo.components.common.IdentityService",
        "meevo.components.logging.LoggingService", "meevo.components.common.SecurityService",
        "meevo.components.tracking.TrackingService",
        "$rootScope", "$scope", "$state", "meevo.ContextParams",
        'meevo.components.short-cuts.ShortCutsService',

          "meevo.components.busy.BusyService", "$translate"];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
          protected dataService: Meevo.Components.BaseClasses.IDataService,
          protected modalService: Meevo.Components.Modal.IModalService,
          protected identityService: Meevo.Components.Common.IIdentityService,
          protected loggingService: Meevo.Components.Logging.ILoggingService,
          protected securityService: Meevo.Components.Common.ISecurityService,
          protected trackingService: Meevo.Components.Tracking.ITrackingService,
          protected $rootScope: angular.IRootScopeService,
          protected $scope: angular.IScope,
          protected $state: any,
          protected contextParams: any,
          protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,

          protected busyService: Meevo.Components.Busy.IBusyService,
          protected $translate: angular.translate.ITranslateService) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.criteria = {
                includeActive: true,
                includeInactive: false,
                includeDeleted: false,
                displayName: null,
                payInOutType: "",
                coFilterByLocationId: null,
                location: null,
                businessType: null,
                maintenanceMode: true
            };
            if (identityService.inCentralOfficeMode()) {
                this.criteria.coSearchType = Model.CoSearchType.CentralOffice;
            }
        }

        /**
        * Creates the context for editing/adding an item.
        * @return {}
        */
        createContext(): void {
                let rc = this;
                rc.busyService.start();
                rc.securityService.checkSection(rc.meevoSecurityKeys.REGISTER_PAYINOUTREASON).then(() => {
                rc.busyService.stop();
                rc.context = new PayInOutReasonsContext(rc.appSettings, rc.dataService, rc.modalService, rc.identityService, rc.loggingService, this.securityService, rc.trackingService, rc.$rootScope);
                rc.context.activate(rc.selectedItemId, null, rc.asLocationId);
                rc.context.deactivate = () => {
                    this.visualState = Model.MaintenanceFormVisualState.Search;
                }
                // Use translate service to populate field list
                this.context.locationFieldList =
                    [
                        { field: 'ObjectState', label: this.$translate.instant("HEADER_STATUS"), checked: false },
                    ];
            }).catch(() => {
                this.busyService.stop();
            });
        }

        clearSearch() {
            this.criteria.includeActive = true;
            this.criteria.includeInactive = false;
            this.criteria.includeDeleted = false;
            this.criteria.displayName = null;
            this.criteria.payInOutType = "";
            this.criteria.coFilterByLocationId = null;
            this.criteria.location = null;
            this.criteria.businessType = null;
            this.criteria.maintenanceMode = true;
        }
  }

    angular.module("meevo.plugins.payinoutreasons")
        .controller("meevo.plugins.payinoutreasons.PayInOutReasonsController", PayInOutReasonsController);
}